export default "__VITE_PUBLIC_ASSET__0be469a5__"